/**
 * CetusEd NextGen — the authenticated landing.
 *
 * A minimal but REAL authenticated view: it calls useCurrentUser (GET
 * /api/auth/me) and shows the actual signed-in identity, plus a working sign-out
 * button. ⛔4 — the user shown is the REAL /me result. If /me is unreachable it
 * shows the REAL error, never a placeholder identity, and still offers sign-out.
 */
import { useNavigate } from 'react-router-dom'
import { useCurrentUser, useLogout } from '../../api/hooks/useAuth'

export function AuthenticatedHome() {
  const navigate = useNavigate()
  const me = useCurrentUser()
  const logout = useLogout()

  function onLogout() {
    logout.mutate(undefined, {
      onSettled: () => navigate('/login', { replace: true }),
    })
  }

  return (
    <main style={{ maxWidth: '48rem', margin: '0 auto', padding: '2rem 1.5rem', font: '400 1rem system-ui, sans-serif' }}>
      <header style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1.5rem' }}>
        <strong style={{ fontSize: '1.15rem', color: '#0f2a4a' }}>CetusEd</strong>
        <button
          type="button"
          data-testid="logout-button"
          onClick={onLogout}
          disabled={logout.isPending}
          style={{
            padding: '0.45rem 0.9rem',
            fontWeight: 600,
            color: '#0f2a4a',
            background: '#e2e8f0',
            border: '1px solid #cbd5e1',
            borderRadius: '0.4rem',
            cursor: 'pointer',
          }}
        >
          {logout.isPending ? 'Signing out…' : 'Sign out'}
        </button>
      </header>

      {me.isPending ? (
        <p role="status" aria-live="polite">Loading your profile…</p>
      ) : null}

      {me.isError ? (
        <div role="alert" style={{ color: '#b91c1c' }}>
          <p>We could not load your profile.</p>
          <p style={{ fontSize: '0.85rem' }}>{me.error.message}</p>
        </div>
      ) : null}

      {me.data ? (
        <p data-testid="signed-in-user" style={{ fontSize: '1.1rem' }}>
          Signed in as <strong>{me.data.name}</strong> ({me.data.role}, {me.data.districtId})
        </p>
      ) : null}
    </main>
  )
}
